<mat-card class="height-100">
  <mat-card-header>
    <mat-card-title>
      Adicionar vendedor
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Dados" style="flex: 1;">
        <ng-template mat-tab-label>
          Dados
          <i
            *ngIf="formDadosValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <div class="flex width-100">
          <div class="flex-column mt-2 col-md-4">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>CPF/CNPJ </mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('cpf_cnpj')"
                mask="000.000.000-00||00.000.000/0000-00"
                (blur)="checkCpfCnpj()"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('repeated')
              "
            >
              {{ messages.cpf_cnpj.repeated }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('required')
              "
            >
              {{ messages.cpf_cnpj.required }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('pattern')
              "
            >
              {{ messages.cpf_cnpj.pattern }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('duplicate')
              "
            >
              {{ messages.cpf_cnpj.duplicate }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('maxlength')
              "
            >
              {{ messages.cpf_cnpj.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCPF')
              "
            >
              {{ messages.cpf_cnpj.validateCPF }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('cpf_cnpj').touched &&
                form.get('cpf_cnpj').hasError('validateCNPJ')
              "
            >
              {{ messages.cpf_cnpj.validateCNPJ }}
            </small>
          </div>
          <div class="flex-column mt-2 col-md-8">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Nome/razão social</mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('nome_razao_social')"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('nome_razao_social').touched &&
                form.get('nome_razao_social').hasError('required')
              "
            >
              {{ messages.nome_razao_social.required }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('nome_razao_social').touched &&
                form.get('nome_razao_social').hasError('maxlength')
              "
            >
              {{ messages.nome_razao_social.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('nome_razao_social').touched &&
                form.get('nome_razao_social').hasError('minlength')
              "
            >
              {{ messages.nome_razao_social.minlength }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('nome_razao_social').touched &&
                form.get('nome_razao_social').hasError('isEmptyValue')
              "
            >
              {{ messages.nome_razao_social.isEmptyValue }}
            </small>
          </div>
        </div>

        <div class="flex width-100">
          <div class="flex-column mt-2 col-md-6">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Apelido/nome fantasia</mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('apelido_nome_fantasia')"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('apelido_nome_fantasia').touched &&
                form.get('apelido_nome_fantasia').hasError('maxlength')
              "
            >
              {{ messages.apelido_nome_fantasia.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('apelido_nome_fantasia').touched &&
                form.get('apelido_nome_fantasia').hasError('minlength')
              "
            >
              {{ messages.nome_razao_social.minlength }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('apelido_nome_fantasia').touched &&
                form.get('apelido_nome_fantasia').hasError('isEmptyValue')
              "
            >
              {{ messages.nome_razao_social.isEmptyValue }}
            </small>
          </div>
          <div class="flex-column mt-2 col-md-6">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Inscrição estadual/RG</mat-label>
              <input
                matInput
                type="text"
                (keydown)="notText($event)"
                (blur)="checkRgInscEstadual()"
                [formControl]="form.get('rg_insc_est')"
              />
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('rg_insc_est').touched &&
                form.get('rg_insc_est').hasError('pattern')
              "
            >
              {{ messages.rg_insc_est.pattern }}
            </small>
            <small
              class="p-error"
              *ngIf="
                form.get('rg_insc_est').touched &&
                form.get('rg_insc_est').hasError('maxlength')
              "
            >
              {{ messages.rg_insc_est.maxlength }}
            </small>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('existSpecialChar')"
            >
              {{ messages.rg_insc_est.existSpecialChar }}
            </small>
            <small
              class="p-error"
              *ngIf="form.get('rg_insc_est').hasError('isEmptyValue')"
            >
              {{ messages.rg_insc_est.isEmptyValue }}
            </small>
          </div>
        </div>
        <div class="flex width-100">
          <div class="flex-column mt-2 col-md-3">
            <mat-form-field class="width-100" appearance="outline">
              <mat-label>Data de nascimento</mat-label>
              <input
                matInput
                type="text"
                [formControl]="form.get('data_nascimento')"
                [matDatepicker]="picker"
                fastFormatData
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
            <small
              class="p-error"
              *ngIf="
                form.get('data_nascimento').touched &&
                form.get('data_nascimento').hasError('matDatepickerParse')
              "
            >
              Essa data é inválida
            </small>
            <small
              class="p-error"
              id="error-data-nascimento"
              *ngIf="form.get('data_nascimento').touched &&
              form.get('data_nascimento').hasError('invalidDate')"
            >
              Data não pode ser posterior a atual
            </small>
          </div>
          <fast-autocomplete
            #input
            *ngIf="temEquipe()"
            id="field-user"
            [autoFirst]="false"
            placeholder="Equipe de vendas"
            [value_order]="'nome'"
            [pageValue]="'0'"
            [pageSizeValue]="'20'"
            (clearSelection)="form.get('equipe_venda_id').reset()"
            class="mt-2 col-md-5"
            displayField="nome"
            [domain_id]="tokenService.getDomain().id"
            [messages]="{
              typeIs: 'Informe um valor válido',
              isEmptyValue: 'Valor inválido: remova os espaços!'
            }"
            [control]="form.get('equipe_venda_id')"
            [entityService]="evendaService"
            [initDataWithEmpty]="true"
          ></fast-autocomplete>
          <div class="mt-2 col-md-4">
            <autocomplete-users
              *ngIf="temUsuario()"
              #input
              [autoFirst]="false"
              required
              [notShowResultsFirst]="false"
              [control]="form.get('user')"
              (clearSelection)="form.get('user').reset()"
              [user_id]="user_id"
              placeholder="Usuário"
              [domain_id]="tokenService.getDomain().id"
              aria-autocomplete="off"
              displayField="name"
              [messages]="{
                typeIs: 'Informe um valor válido',
                isEmptyValue: 'Valor inválido: remova os espaços!'
              }"
              [pageValue]="'0'"
              [pageSizeValue]="'10'"
            ></autocomplete-users>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Endereço" style="flex: 1;">
        <ng-template>
          Endereço
          <i
            *ngIf="formAddressValid"
            class="mdi mdi-alert-circle red"
            matTooltip="Preencha as informações corretamente"
          ></i>
        </ng-template>
        <app-fast-endereco [entity]="entity.parceiro"></app-fast-endereco>
      </mat-tab>
      <mat-tab label="Contatos">
        <app-fast-contato [entity]="entity.parceiro"></app-fast-contato>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
  <mat-card-actions>
    <div class="mt-2 col-md-12 flex justify-content-end">
      <button mat-stroked-button color="warn" [matDialogClose]="undefined">
        Cancelar
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="onSubmit()"
        [disabled]="!formValid"
      >
        Cadastrar
      </button>
    </div>
  </mat-card-actions>
</mat-card>
